<template>
    <div class="auth">
        <transition name="fade" mode="out-in">
            <div v-if="registrationComplete">
                <h3>Account succesvol aangemaakt</h3>
                <p>Er is een e-mail verstuurd naar {{account.email}}. In die e-mail staat hoe u uw registratie kunt afronden.</p>
                <a href="#" class="button--cta" @click.prevent="changeAuthView('LoginForm')">Terug naar inlogscherm</a>
            </div>

            <form class="form" v-else>
                <div class="alert--error" v-if="error !== undefined && error.length > 0">{{error}}</div>
                <h3>Maak account aan </h3>
                <p class="is-muted">* Verplichte velden</p>
                <h4>Accountgegevens</h4>

                <div class="form__group">
                    <input class="form__input--text" type="text" autocomplete="email" placeholder="Emailadres *" v-model="account.email"/>
                </div>
                <div class="form__group">
                    <input class="form__input--text" type="text" autocomplete="email" placeholder="Herhaal e-mailadres *" v-model="account.repeat_email"/>
                </div>
                <div class="form__group">
                    <input class="form__input--text" type="password" autocomplete="new-password" placeholder="Wachtwoord *" v-model="account.password"/>
                </div>
                <div class="form__group">
                    <input class="form__input--text" type="password" autocomplete="new-password" placeholder="Herhaal wachtwoord *" v-model="account.repeat_password" />
                </div>

                <h4>Persoonlijke gegevens</h4>

                <div class="form__group">
                    <input class="form__input--text" type="text" placeholder="Voornaam *" v-model="account.first_name" />
                </div>
                <div class="form__group">
                    <input class="form__input--text" type="text" placeholder="Achternaam *" v-model="account.last_name"/>
                </div>
                <div class="form__group">
                    <div class="row">
                        <div class="col-8">
                            <input class="form__input--text" type="text" placeholder="Straat" />
                        </div>
                        <div class="col-4">
                            <input class="form__input--text" type="text" placeholder="Huisnummer" />
                        </div>
                    </div>
                </div>
                <div class="form__group">
                    <div class="row">
                        <div class="col-4">
                            <input class="form__input--text" type="text" placeholder="Postcode" />
                        </div>
                        <div class="col-8">
                            <input class="form__input--text" type="text" placeholder="Woonplaats" />
                        </div>
                    </div>
                </div>
                <div class="form__group">
                    <input class="form__input--text" type="text" placeholder="Telefoonnummer" />
                </div>
                <div class="form__buttons">
                    <button type="submit" class="button--cta" @click.prevent="register">Maak account aan</button>
                    <router-link :to="{ name: 'sign-in' }" class="button--link">Annuleren</router-link>
                </div>
            </form>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import {REGISTER} from '../../../store/modules/auth';

    //TODO add form field validation
    @Component
    export default class RegisterForm extends Vue {
        name = 'account-form';
        registrationComplete = false;

        account = {
            email: '',
            repeat_email: '',
            password: '',
            repeat_password: '',
            first_name: '',
            last_name: ''
        };

        error = '';

        created() {
            //Reset values.
            this.registrationComplete = false;
            this.account = {
                email: '',
                repeat_email: '',
                password: '',
                repeat_password: '',
                first_name: '',
                last_name: ''
            };
        }

        /**
         * Register a new account.
         */
        register() {
            //
            this.$store.dispatch(REGISTER, this.account)
                .then(() => {
                    this.registrationComplete = true;
                })
                .catch((e) => {
                    // TODO check error message handling.
                    if (e.response && e.response.data) {
                        var data = e.response.data;
                        this.error = data.errors[0].msg;
                        console.error('[ Login ]', this.error);
                    }
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/RegisterForm.vue